(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[995],{

/***/ 8056:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
var t=__webpack_require__(5893),e=__webpack_require__(7294);function a(t){return t&&"object"==typeof t&&"default"in t?t:{default:t}}var d=a(__webpack_require__(4184)),i="pin-button___10982",r="pin-button_compact___d8v2v",n="pin-button_standard___1cj18",l="pin-button_large___d8u16",o="pin-button_full-width___lxgy4";const s=e.forwardRef((({onClick:e,type:a,fullWidth:s,disabled:u,children:c,rel:_,title:f,target:b,size:p,icon:m,additionalClassName:v,tabIndex:h,testId:x,href:g,id:y,...j},C)=>{const k={[r]:"compact"===p,[n]:"standard"===p,[l]:"large"===p,[o]:s},q=void 0!==g&&!u,I=q?"a":"button";return t.jsxs(I,{href:g,ref:C,onClick:e,type:a,tabIndex:u?-1:h,disabled:q?void 0:u,className:d.default(i,k,v),rel:_,target:b,title:f,"data-testid":x,id:y,...j,"aria-disabled":u||void 0,children:[m,c]})}));s.displayName="Button",s.defaultProps={onClick:()=>{},fullWidth:!1,disabled:!1,size:"standard",icon:void 0},module.exports=s;


/***/ }),

/***/ 4471:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
var e=__webpack_require__(5893),r=__webpack_require__(7294),t=__webpack_require__(8056);__webpack_require__(4184);var a="pin-button___11dvn";const i=r.forwardRef(((r,i)=>e.jsx(t,{additionalClassName:a,...r,ref:i})));i.displayName="ButtonOutlinePrimary",module.exports=i;


/***/ }),

/***/ 1895:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
var e=__webpack_require__(5893),n=__webpack_require__(7294);function t(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var i=t(__webpack_require__(4184)),c="pin-chip___i8w1j",s="pin-chip_focused___15ch8",a="pin-chip__input___1aqst",r="pin-chip__label___bwmb8",d="pin-chip__label__inner___7g3rs",o="pin-chip_compact___12vg1",u="pin-chip__prefix-icon___167oq",_="pin-chip__suffix-icon___1i1uw";const p=({type:t,name:p,disabled:l,isSelected:f,defaultIsSelected:m,children:h,prefixIcon:x,suffixIcon:v,size:y,onChange:j,testId:b})=>{const w=n.useRef(!1),[N,g]=n.useState(!1),k={[o]:"compact"===y,[s]:N};n.useEffect((()=>{function e(e){e.metaKey||e.altKey||e.ctrlKey||(w.current=!0)}function n(){w.current=!1}return document.addEventListener("keydown",e),document.addEventListener("pointerdown",n),()=>{document.removeEventListener("keydown",e),document.removeEventListener("pointerdown",n)}}),[]);return e.jsxs("label",{className:i.default(c,k),"data-testid":b,children:[e.jsx("input",{className:a,type:t,name:p,disabled:l,checked:f,defaultChecked:m,onChange:e=>{j&&j(e.target.checked)},onFocus:function(){g(w.current)},onBlur:function(){g(!1)}}),e.jsxs("span",{className:r,children:[x&&e.jsx("span",{className:u,children:x}),e.jsx("span",{className:d,children:h}),v&&e.jsx("span",{className:_,children:v})]})]})};p.defaultProps={type:"radio",size:"default",prefixIcon:void 0},p.displayName="Chip",module.exports=p;


/***/ }),

/***/ 2471:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
var r=__webpack_require__(5893);module.exports=({color:o="currentColor",...e})=>{const t="currentColor"===o?o:"var(--color-icon-"+o+")";return r.jsx("svg",{width:16,height:16,viewBox:"0 0 16 16",fill:"none",xmlns:"http://www.w3.org/2000/svg",role:"img",...e,children:r.jsx("path",{d:"m3 5.778 5 4.444 5-4.444",stroke:t,strokeWidth:1.25})})};


/***/ }),

/***/ 1355:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
var e=__webpack_require__(5893),t=__webpack_require__(7294);function r(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var n=r(__webpack_require__(4184)),a="pin-otp-input-form___1ov77",u="pin-otp-input___av09w",s="pin-otp-input_has-error___1bwf6";const o=/^[0-9]+$/;function c(e){return e&&o.test(e)?e:""}const i=t.forwardRef((({autoFocus:r=!0,defaultValue:i,disabled:l,hasError:f,onChange:p,onSubmit:d,testId:m,totalInputElements:b=4,value:h},g)=>{const v=n.default(a,{[s]:f}),{isValuePropAvailable:x,sanitizedValueProp:y}=t.useMemo((()=>({isValuePropAvailable:"string"==typeof h,sanitizedValueProp:c(h)})),[h]),[_,w]=t.useState(c(i)||y),k=t.useRef(_),j=t.useRef([]);t.useImperativeHandle(g,(()=>({clearValue(){w(""),k.current="",j.current[0]?.focus()}})),[]);const A=t.useCallback((e=>t=>{j.current[e]=t}),[]),C=t.useCallback((e=>{const t=Number(e.currentTarget.dataset.index);switch(e.key){case"Delete":case"Backspace":{e.preventDefault();const r=_.split("");r.splice(t,1);const n=r.join("").substring(0,b);w(n),k.current=n,"function"==typeof p&&p(n);const a=Math.max(t-1,0);j.current[a]?.focus();break}case"ArrowLeft":{e.preventDefault();const r=Math.max(t-1,0);j.current[r]?.focus();break}case"ArrowRight":{e.preventDefault();const r=Math.min(t+1,b-1);j.current[r]?.focus()}}}),[p,b,_]),M=t.useCallback((async e=>{const t=Number(e.currentTarget.dataset.index),r=e.target.value;if(!o.test(r))return;const n=_.split(""),a=r.substring(0,b-t).split(""),u=t+a.length,s=Math.min(u,b-1);for(let e=0;e<a.length;e++)n[t+e]=a[e];const c=n.join("").substring(0,b);w(c),k.current=c,"function"==typeof p&&p(c),j.current[s]?.focus(),c.length===b&&"function"==typeof d&&await d(c)}),[p,d,b,_]);return t.useEffect((()=>{r&&j.current[0]?.focus()}),[r]),t.useEffect((()=>{x&&y!==k.current&&(w(y),k.current=y)}),[x,y]),e.jsx("form",{className:v,"data-testid":m,children:Array.from({length:b}).map(((t,r)=>{const n=`txt-otp-${r+1}`;return e.jsx("input",{autoComplete:"one-time-code",className:u,"data-index":r,"data-testid":n,disabled:l,inputMode:"numeric",onChange:M,onKeyDown:C,ref:A(r),value:_.charAt(r)},`otp-input-${r}`)}))})}));i.displayName="OTPInput",module.exports=i;


/***/ }),

/***/ 8505:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
var e=__webpack_require__(5893),t=__webpack_require__(7294),i=__webpack_require__(4184),n=__webpack_require__(4360);function l(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a=l(i);function s(){return e.jsx("svg",{"aria-label":"Kembali",width:"24",height:"24",viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:e.jsx("path",{d:"M10.7143 19.5L3 12M10.7143 4.5L3 12M3 12L21 12",stroke:"currentColor",strokeWidth:"1.5"})})}function o(){return e.jsx("svg",{"aria-label":"Tutup",width:"24",height:"24",viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:e.jsx("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M10.9394 11.9398L3 19.8792L4.06066 20.9399L12 13.0005L19.9394 20.9399L21 19.8792L13.0607 11.9398L20.9399 4.06066L19.8792 3L12 10.8792L4.12085 3L3.06019 4.06066L10.9394 11.9398Z",fill:"currentColor"})})}var r="pin-top-navigation___jf5ka",c="pin-top-navigation__left___fvjx8",d="pin-top-navigation__right___13cu8",u="pin-top-navigation_has-right-section___5rrld",h="pin-top-navigation__title___p2hnj";module.exports=({onBack:i,onClose:l,rightSection:p,testId:_,title:v,titleComponent:x="h3",variant:j="back"})=>{const g=a.default(r,{[u]:!!p}),{buttonTitle:m,handleClick:f,icon:L}=t.useMemo((()=>"close"===j?{buttonTitle:"Tutup",handleClick:l,icon:e.jsx(o,{})}:{buttonTitle:"Kembali",handleClick:i,icon:e.jsx(s,{})}),[i,l,j]),w=t.useMemo((()=>"string"==typeof v?e.jsx(x,{className:h,children:v}):t.cloneElement(v,{className:a.default(v.props?.className,h)})),[v,x]);return e.jsxs("header",{className:g,"data-testid":_,children:[e.jsxs("nav",{className:c,children:[e.jsxs("button",{onClick:f,title:m,children:[e.jsx(n,{children:m}),L]}),w]}),p&&e.jsx("div",{className:d,children:p})]})};


/***/ }),

/***/ 4360:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
var e=__webpack_require__(5893);module.exports=({children:r})=>e.jsx("span",{style:{clip:"rect(0, 0, 0, 0)",border:0,height:"1px",margin:"-1px",overflow:"hidden",padding:0,position:"absolute",whiteSpace:"nowrap",width:"1px"},children:r});


/***/ }),

/***/ 6210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_regex_commonRegex__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6934);




var MetaHead = function(param) {
    var title = param.title, description = param.description;
    var metaTitle = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:title",
                    content: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:title",
                    content: title
                })
            ]
        });
    }, [
        title
    ]);
    var metaDescription = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var descriptionText = (description !== null && description !== void 0 ? description : "").replace(_utils_regex_commonRegex__WEBPACK_IMPORTED_MODULE_3__/* .removedHtmlTagRegex */ .i, "");
        if (!descriptionText) return null;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "description",
                    content: descriptionText
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:description",
                    content: descriptionText
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:description",
                    content: descriptionText
                })
            ]
        });
    }, [
        description
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            metaTitle,
            metaDescription
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MetaHead);


/***/ }),

/***/ 7040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _pinvest_sirius_chip_dist_chip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1895);
/* harmony import */ var _pinvest_sirius_chip_dist_chip__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_pinvest_sirius_chip_dist_chip__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8642);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2036);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_5__);







var convertInitialValue = function(values) {
    if (typeof values === "string") return [
        values
    ];
    return values;
};
var MultiChipSelect = function(param) {
    var options = param.options, groupName = param.groupName, type = param.type, _values = param.values, values = _values === void 0 ? "" : _values, scrollable = param.scrollable, onChange = param.onChange, disabled = param.disabled, testId = param.testId;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(convertInitialValue(values)), selectedChips = ref[0], setSelectedChips = ref[1];
    var isChipSelected = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(optionValue) {
        if (typeof selectedChips === "string") {
            return selectedChips === optionValue;
        }
        return selectedChips.includes(optionValue);
    }, [
        selectedChips
    ]);
    var handleChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(newValues) {
        if (typeof onChange === "function") {
            if (typeof values === "string") {
                onChange(newValues[0]);
                return;
            }
            onChange(newValues);
        }
    }, [
        onChange,
        values
    ]);
    var handleChipClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(optionValue, checked) {
        if (type === "radio") {
            setSelectedChips([
                optionValue
            ]);
            handleChange([
                optionValue
            ]);
            return;
        }
        var newSelectedChips = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(selectedChips);
        if (checked) {
            newSelectedChips = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(selectedChips).concat([
                optionValue
            ]);
        } else {
            newSelectedChips = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(selectedChips).filter(function(v) {
                return v !== optionValue;
            });
        }
        setSelectedChips(newSelectedChips);
        handleChange(newSelectedChips);
    }, [
        selectedChips,
        type,
        handleChange
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_5___default().chips), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, (_styles_module_css__WEBPACK_IMPORTED_MODULE_5___default().chips_scrollable), !!scrollable)),
        children: options.map(function(opt, index) {
            var chipClickHandlerFn = function() {
                return function(checked) {
                    handleChipClick(opt.value, checked);
                };
            };
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_pinvest_sirius_chip_dist_chip__WEBPACK_IMPORTED_MODULE_2___default()), {
                name: groupName,
                disabled: disabled,
                type: type,
                isSelected: isChipSelected(opt.value),
                onChange: chipClickHandlerFn(),
                testId: "".concat(testId, "-").concat(index + 1),
                children: opt.label
            }, opt.value);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MultiChipSelect);


/***/ }),

/***/ 3547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _pinvest_sirius_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4936);
/* harmony import */ var _pinvest_sirius_button_dist_button_outline_primary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4471);
/* harmony import */ var _pinvest_sirius_button_dist_button_outline_primary__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_pinvest_sirius_button_dist_button_outline_primary__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _pinvest_sirius_divider_dist_divider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1508);
/* harmony import */ var _pinvest_sirius_divider_dist_divider__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_pinvest_sirius_divider_dist_divider__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _pinvest_sirius_input_dist_otp_input__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1355);
/* harmony import */ var _pinvest_sirius_input_dist_otp_input__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_pinvest_sirius_input_dist_otp_input__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8642);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_shared_Text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1823);
/* harmony import */ var _constants_externalUrls__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7928);
/* harmony import */ var _constants_verification__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7134);
/* harmony import */ var _contexts_parsedUserAgent__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4407);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4529);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_10__);













var OTPForm = function(param) {
    var phoneNumber = param.phoneNumber, verificationMethod = param.verificationMethod, tooglePreviousForm = param.tooglePreviousForm, resendOtp = param.resendOtp, verifyOtp = param.verifyOtp, errorVerifyOtp = param.errorVerifyOtp;
    var isMobile = (0,_contexts_parsedUserAgent__WEBPACK_IMPORTED_MODULE_9__/* .useParsedUserAgent */ .e)().isMobile;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(30), resendOtpTime = ref[0], setResendOtpTime = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var timeoutId = setTimeout(function() {
            if (resendOtpTime > 0) {
                setResendOtpTime(resendOtpTime - 1);
            }
        }, 1000);
        return function() {
            clearTimeout(timeoutId);
        };
    }, [
        resendOtpTime
    ]);
    var verificationMethodLabel = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var ref;
        return (ref = (0,_constants_verification__WEBPACK_IMPORTED_MODULE_8__/* .verificationTypeMapper */ .px)(verificationMethod)) === null || ref === void 0 ? void 0 : ref.label;
    }, [
        verificationMethod
    ]);
    var isResendEnabled = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (resendOtpTime > 0) {
            return false;
        }
        return true;
    }, [
        resendOtpTime
    ]);
    var handleOTPInputSubmit = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        verifyOtp(value);
    }, [
        verifyOtp
    ]);
    var handleResendOtpClicked = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        setResendOtpTime(30);
        resendOtp();
    }, [
        resendOtp
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_10___default()["otp-form"]),
        "data-testid": "frm-otp",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    !isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                typography: "label1",
                                children: "Masukkan Kode Verifikasi"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_shared_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        typography: "body2",
                        children: [
                            "Masukkan kode verifikasi yang Anda terima melalui ",
                            verificationMethodLabel,
                            " di ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                children: phoneNumber
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_10___default()["otp-form__input-section"]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_pinvest_sirius_input_dist_otp_input__WEBPACK_IMPORTED_MODULE_5___default()), {
                    hasError: !!errorVerifyOtp,
                    onSubmit: handleOTPInputSubmit
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_10___default()["otp-form__section_center"]), (_styles_module_css__WEBPACK_IMPORTED_MODULE_10___default()["otp-form__section"])),
                "data-testid": "text-otp-errorMessage",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    typography: "body2",
                    color: "negative",
                    children: errorVerifyOtp
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_10___default()["otp-form__section_center"]), (_styles_module_css__WEBPACK_IMPORTED_MODULE_10___default()["otp-form__section_margin-bottom"])),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_shared_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    typography: "body2",
                    children: [
                        "Belum menerima kode verifikasi? Tunggu ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("b", {
                            children: [
                                resendOtpTime,
                                " detik"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_10___default()["otp-form__section_center"]), (_styles_module_css__WEBPACK_IMPORTED_MODULE_10___default()["otp-form__cta-section"])),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_pinvest_sirius_button_dist_button_outline_primary__WEBPACK_IMPORTED_MODULE_3___default()), {
                            testId: "btn-resend-otp",
                            fullWidth: true,
                            size: "large",
                            disabled: !isResendEnabled,
                            onClick: handleResendOtpClicked,
                            children: "Kirim Ulang Kode Verifikasi"
                        })
                    }),
                    tooglePreviousForm && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_10___default()["otp-form__section_center"]), (_styles_module_css__WEBPACK_IMPORTED_MODULE_10___default()["otp-form__cta-section"])),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pinvest_sirius_button__WEBPACK_IMPORTED_MODULE_2__/* .ButtonLink */ .ZP, {
                            testId: "btn-otpForm-changePhoneNumber",
                            onClick: tooglePreviousForm,
                            fullWidth: true,
                            size: "large",
                            children: "Ubah Nomor Handphone"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_pinvest_sirius_divider_dist_divider__WEBPACK_IMPORTED_MODULE_4___default()), {
                variant: "line",
                gutter: 16
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_10___default()["otp-form__section_center"]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_shared_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    typography: "body2",
                    color: "subtle",
                    children: [
                        "Butuh Bantuan atau Solusi ? Silakan ",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                            href: _constants_externalUrls__WEBPACK_IMPORTED_MODULE_12__/* .waPinfinance2 */ .Y,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    color: "primary",
                                    typography: "body2",
                                    children: "Hubungi Kami"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OTPForm);


/***/ }),

/***/ 1785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _pinvest_sirius_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4936);
/* harmony import */ var _pinvest_sirius_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6045);
/* harmony import */ var _pinvest_sirius_top_navigation_dist_top_navigation_inner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8505);
/* harmony import */ var _pinvest_sirius_top_navigation_dist_top_navigation_inner__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_pinvest_sirius_top_navigation_dist_top_navigation_inner__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8642);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3810);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_6__);







var CenterContentTemplate = function(param) {
    var children = param.children, onBack = param.onBack, title = param.title, _mobileHidden = param.mobileHidden, mobileHidden = _mobileHidden === void 0 ? false : _mobileHidden, _showBackButton = param.showBackButton, showBackButton = _showBackButton === void 0 ? true : _showBackButton;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().navbar), mobileHidden && (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default()["navbar_mobile-hidden"])),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_pinvest_sirius_top_navigation_dist_top_navigation_inner__WEBPACK_IMPORTED_MODULE_4___default()), {
                    title: title,
                    onBack: onBack
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().template),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().template__wrapper),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default()["template__back-button"]),
                            children: showBackButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pinvest_sirius_button__WEBPACK_IMPORTED_MODULE_2__/* .ButtonOutline */ .Ig, {
                                testId: "btn-back-template",
                                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pinvest_sirius_icons__WEBPACK_IMPORTED_MODULE_3__/* .ArrowLeft20Icon */ .UYk, {}),
                                onClick: onBack,
                                children: "Kembali"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().template__content),
                            children: children
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CenterContentTemplate);


/***/ }),

/***/ 7928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ waPinfinance2; },
/* harmony export */   "b$": function() { return /* binding */ whatsappPinfinancePaymentConfirm; },
/* harmony export */   "by": function() { return /* binding */ typeFormBL; }
/* harmony export */ });
/* unused harmony export waPinfinance */
/* eslint-disable max-len */ var waPinfinance = "https://api.whatsapp.com/send/?phone=6281322276289&text=Halo Pinhome, Saya ingin bertanya mengenai Pinhome Financial.&type=phone_number&app_absent=0";
var waPinfinance2 = "https://api.whatsapp.com/send/?phone=6281310803908&text=Halo Pinhome, Saya ingin bertanya mengenai Pinhome Financial.&type=phone_number&app_absent=0";
var typeFormBL = "https://pinhome.typeform.com/BridgingLoan";
var whatsappPinfinancePaymentConfirm = function(amount) {
    return "https://api.whatsapp.com/send/?phone=6281310803908&text=Halo Tim Pinhome,%0a%0aSaya sudah melakukan pembayaran tagihaan komisi instan sebesar ".concat(amount !== null && amount !== void 0 ? amount : "[Jumlah]", "%0a%0aTerima kasih [Masukan gambar bukti bayar]");
};


/***/ }),

/***/ 7134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DY": function() { return /* binding */ verificationTypeMapByValue; },
/* harmony export */   "Kc": function() { return /* binding */ verificationTypeOptions; },
/* harmony export */   "R4": function() { return /* binding */ VerificationType; },
/* harmony export */   "px": function() { return /* binding */ verificationTypeMapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2222);

var VerificationType;
(function(VerificationType) {
    VerificationType["WHATSAPP"] = "whatsapp";
    VerificationType["SMS"] = "sms";
})(VerificationType || (VerificationType = {}));
var verificationTypeOptions = [
    {
        label: "WhatsApp",
        value: VerificationType.WHATSAPP
    },
    {
        label: "SMS",
        value: VerificationType.SMS
    }
];
var verificationTypeMapper = function(verificationType) {
    if ((typeof verificationType === "undefined" ? "undefined" : (0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(verificationType)) != undefined) {
        return verificationTypeOptions.find(function(optionItem) {
            return optionItem.value === verificationType;
        });
    }
};
var verificationTypeMapByValue = function(value) {
    if (value == VerificationType.SMS) {
        return VerificationType.SMS;
    } else if (value == VerificationType.WHATSAPP) {
        return VerificationType.WHATSAPP;
    }
};


/***/ }),

/***/ 9633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useFeatureFlag; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5461);


/**
 * A Custom React hook to query for `featureFlags`.
 * 
 * The return type of this hook is object with keys are feature flag keys and values are boolean.
 * 
 * @example
 * const {
 *  feature_flag_a: flagA,
 *  feature_flag_b: flagB
 * } = useFeatureFlag();
 */ function useFeatureFlag() {
    var flagConfig = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context__WEBPACK_IMPORTED_MODULE_1__/* .FeatureFlagContext */ .p);
    if (typeof flagConfig === "undefined") {
        throw new Error("`useFeatureFlag` was used outside of `FeatureFlagProvider`");
    }
    return flagConfig;
}


/***/ }),

/***/ 4407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ useParsedUserAgent; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8994);


function useParsedUserAgent() {
    var parsedUserAgent = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context__WEBPACK_IMPORTED_MODULE_1__/* .ParsedUserAgentContext */ .g);
    if (typeof parsedUserAgent === "undefined") {
        throw new Error("`useParsedUserAgent` was used outside of `ParsedUserAgentProvider`");
    }
    return parsedUserAgent;
}


/***/ }),

/***/ 4110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ requestOtp_useRequestOtp; }
});

// EXTERNAL MODULE: ./src/repositories/useMutation.ts
var useMutation = __webpack_require__(8858);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/repositories/fetcher.ts
var fetcher = __webpack_require__(5140);
// EXTERNAL MODULE: ./src/repositories/utils.ts + 10 modules
var utils = __webpack_require__(7115);
;// CONCATENATED MODULE: ./src/repositories/auth/requestOtp/index.ts




var requestOtp = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(body) {
        var data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,fetcher/* default */.Z)({
                        method: "POST",
                        url: "/api/auth/request-otp",
                        body: body,
                        headers: (0,utils/* getHeadersWithBasicAuth */.Iy)()
                    });
                case 2:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function requestOtp(body) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var auth_requestOtp = (requestOtp);

;// CONCATENATED MODULE: ./src/repositories/auth/requestOtp/useRequestOtp.ts


var useRequestOtp = function(options) {
    var resp = (0,useMutation/* default */.Z)(auth_requestOtp, options);
    return resp;
};
/* harmony default export */ var requestOtp_useRequestOtp = (useRequestOtp);


/***/ }),

/***/ 4797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* binding */ useVerifyLoginOtp; },
  "T": function() { return /* binding */ useVerifyRegisterOtp; }
});

// EXTERNAL MODULE: ./src/repositories/useMutation.ts
var useMutation = __webpack_require__(8858);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/repositories/fetcher.ts
var fetcher = __webpack_require__(5140);
// EXTERNAL MODULE: ./src/repositories/utils.ts + 10 modules
var utils = __webpack_require__(7115);
;// CONCATENATED MODULE: ./src/repositories/auth/verifyOtp/index.ts




var verifyLoginOtp = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(body) {
        var data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,fetcher/* default */.Z)({
                        method: "POST",
                        url: "/api/auth/login",
                        body: body,
                        headers: (0,utils/* getHeadersWithBasicAuth */.Iy)()
                    });
                case 2:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function verifyLoginOtp(body) {
        return _ref.apply(this, arguments);
    };
}();
var verifyRegisterOtp = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(body) {
        var data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,fetcher/* default */.Z)({
                        method: "POST",
                        url: "/api/auth/register",
                        body: body,
                        headers: (0,utils/* getHeadersWithBasicAuth */.Iy)()
                    });
                case 2:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function verifyRegisterOtp(body) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/repositories/auth/verifyOtp/useVerifyOtp.ts


var useVerifyLoginOtp = function(options) {
    var resp = (0,useMutation/* default */.Z)(verifyLoginOtp, options);
    return resp;
};
var useVerifyRegisterOtp = function(options) {
    var resp = (0,useMutation/* default */.Z)(verifyRegisterOtp, options);
    return resp;
};


/***/ }),

/***/ 8858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7568);
/* harmony import */ var _builds_pinvest_web_pinfinance_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _builds_pinvest_web_pinfinance_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_pinvest_web_pinfinance_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7115);




// POST | PUT | PATCH with body request is required OR GET with required slug 
// used to create/update/delete/get
var useMutation = function(fetcher, options) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(_utils__WEBPACK_IMPORTED_MODULE_2__/* .fetchReducer */ .QX, _utils__WEBPACK_IMPORTED_MODULE_2__/* .reducerInitialState */ .SO), state = ref[0], dispatch = ref[1];
    var handleSuccess = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(data) {
        if (typeof (options === null || options === void 0 ? void 0 : options.onSuccess) === "function") {
            options.onSuccess(data);
        }
    }, [
        options
    ]);
    var handleError = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(err) {
        if (typeof (options === null || options === void 0 ? void 0 : options.onError) === "function") {
            options.onError(err);
        }
    }, [
        options
    ]);
    var handleFetch = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_pinvest_web_pinfinance_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
            var resp, parsedError;
            return _builds_pinvest_web_pinfinance_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        dispatch({
                            type: "loading",
                            payload: true
                        });
                        _ctx.next = 4;
                        return fetcher(body);
                    case 4:
                        resp = _ctx.sent;
                        dispatch({
                            type: "data",
                            payload: resp
                        });
                        handleSuccess(resp);
                        return _ctx.abrupt("return", resp);
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        parsedError = typeof _ctx.t0 === "string" ? JSON.parse(_ctx.t0) : _ctx.t0;
                        dispatch({
                            type: "error",
                            payload: parsedError
                        });
                        handleError(parsedError);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }));
        return function(body) {
            return _ref.apply(this, arguments);
        };
    }(), [
        fetcher,
        handleSuccess,
        handleError
    ]);
    return {
        data: state.data,
        isLoading: state.isLoading,
        error: state.error,
        fetch: handleFetch
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useMutation);


/***/ }),

/***/ 6986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ signInEvent; }
/* harmony export */ });
var signInEvent = {
    openPage: "sign_in/open_page",
    getResponse: "sign_in/get_response"
};


/***/ }),

/***/ 8664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ signUpEvent; }
/* harmony export */ });
var signUpEvent = {
    openPage: "sign_up/open_page",
    clickButton: "sign_up/click_button",
    getResponse: "sign_up/get_response"
};


/***/ }),

/***/ 6934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ removedHtmlTagRegex; },
/* harmony export */   "k": function() { return /* binding */ thousandSeparatorPositionRegex; }
/* harmony export */ });
var thousandSeparatorPositionRegex = /\B(?=(\d{3})+(?!\d))/g;
var removedHtmlTagRegex = /(<([^>]+)>)/ig;


/***/ }),

/***/ 481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HN": function() { return /* binding */ emailRegex; },
/* harmony export */   "pA": function() { return /* binding */ numberRegex; },
/* harmony export */   "tj": function() { return /* binding */ decimalNumberWithCommaRegex; }
/* harmony export */ });
/* unused harmony export phoneNumberRegex */
var numberRegex = /^[0-9]+$/;
var decimalNumberWithCommaRegex = /^\d+([,\d]?)([\d]+)?$/;
var phoneNumberRegex = /^8[0-9]{8,14}$/;
var emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;


/***/ }),

/***/ 4575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y0": function() { return /* binding */ validatePhoneNumber; },
/* harmony export */   "_u": function() { return /* binding */ validatePhoneNumberOffice; },
/* harmony export */   "oH": function() { return /* binding */ validateEmail; }
/* harmony export */ });
/* unused harmony exports validateEmpty, validateNotSelected */
/* harmony import */ var _utils_regex_inputRegex__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(481);

var validateEmpty = function(value, field) {
    if (value.trim().replace(/ /g, "") == "") {
        return "".concat(field, " wajib diisi");
    }
    return undefined;
};
var validateNotSelected = function(value, field) {
    if (value == null || value == undefined) {
        return "".concat(field, " wajib dipilih");
    }
    return undefined;
};
var validatePhoneNumber = function(phoneNumber) {
    if (!phoneNumber.startsWith("8")) {
        return "Pastikan nomor handphone yang Anda masukkan sudah benar";
    } else if (phoneNumber.length < 9 || phoneNumber.length > 15) {
        return "Harap diisi dengan angka berjumlah 9-15 karakter";
    }
    return undefined;
};
var validateEmail = function(email) {
    if (validateEmpty(email, "Email")) {
        return validateEmpty(email, "Email");
    } else if (!_utils_regex_inputRegex__WEBPACK_IMPORTED_MODULE_0__/* .emailRegex.test */ .HN.test(email)) {
        return "Pastikan email yang Anda ketik sudah benar";
    }
};
var validatePhoneNumberOffice = function(phoneNumber) {
    if (!phoneNumber.startsWith("8") && !phoneNumber.startsWith("2")) {
        return "Nomor Telepon harus diawali dengan 8 atau 2";
    } else if (phoneNumber.length < 7 || phoneNumber.length > 15) {
        return "Harap diisi dengan angka berjumlah 7-15 karakter";
    }
    return undefined;
};


/***/ }),

/***/ 2036:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"chips":"styles_chips__IOtED","chips_scrollable":"styles_chips_scrollable__rWjJ_"};

/***/ }),

/***/ 4529:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"otp-form":"styles_otp-form__Et9Pj","otp-form__label":"styles_otp-form__label__UCe9A","otp-form__input-section":"styles_otp-form__input-section__0q3V2","otp-form__section":"styles_otp-form__section__5F7L3","otp-form__section_center":"styles_otp-form__section_center__WqsW4","otp-form__cta-section":"styles_otp-form__cta-section__yT_v7"};

/***/ }),

/***/ 3810:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"template":"styles_template__nFAxg","template__back-button":"styles_template__back-button__PJ5OA","navbar":"styles_navbar__jSMcG","navbar_mobile-hidden":"styles_navbar_mobile-hidden__1QaOa","template__wrapper":"styles_template__wrapper__fD3yP","template__content":"styles_template__content__XIovp"};

/***/ })

}]);